import { render, staticRenderFns } from "./dummy-register-page.vue?vue&type=template&id=7924b18c&scoped=true&"
import script from "./dummy-register-page.vue?vue&type=script&lang=js&"
export * from "./dummy-register-page.vue?vue&type=script&lang=js&"
import style0 from "./dummy-register-page.vue?vue&type=style&index=0&id=7924b18c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7924b18c",
  null
  
)

export default component.exports